//Use event delegation for anchor links.
$(document).on("click", "a[href^='#']:not(.anchor-link)", function (e) {
    e.preventDefault();
    const elementClick = $(this).attr("href");
    const modalPopup = $(elementClick);
    const isCollapse = $(this).data('toggle') === 'collapse';

    if (modalPopup.hasClass("modal-popup")) {
        modalPopup.addClass("-open");
        $("body").addClass("-overflow-hidden");
    } else if (!isCollapse && !$(this).hasClass('link-content')) {
        const header = $(".site-header");
        const headerHeight = header.innerHeight();

        if (header.hasClass("open-menu")) {
            header.removeClass("open-menu");
            $(".menu-opener").removeClass("-active");
            $("body").removeClass("-overflow-hidden");
        }

        $('html, body').animate({
            scrollTop: modalPopup.offset().top - headerHeight
        }, 2000);
    }
});

//Combine event handlers for close buttons and modal overlays.
$(".modal-popup .close-button, .modal-popup .modal-overlay").on("click", function (e) {
    const header = $(".site-header");
    const modalPopup = $(this).closest(".modal-popup");

    modalPopup.removeClass("-open");

    if (!header.hasClass("open-menu")) {
        $("body").removeClass("-overflow-hidden");
    }
});